import { htmlSafe } from '@ember/template';
import { PhCheckCircle, PhPencilSimple, PhXCircle } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
interface CompletedStepSummarySignature {
  Args: {
    stepNumber: number;
    label: string;
    summary: string;
    summaryKind?: 'course-cash';
    isComplete: boolean;
    onEdit: () => void;
  };
  Element: HTMLButtonElement;
}

const CompletedStepSummary: TOC<CompletedStepSummarySignature> = <template>
  <button
    type="button"
    class="border-b tio-border-default pb-8 tio-row-between w-full text-left cursor-pointer group"
    aria-label={{t "tas.guided.edit_step" step=@label}}
    {{on "click" @onEdit}}
    ...attributes
  >
    <div class="tio-row-tight">
      {{#if @isComplete}}
        <PhCheckCircle @size="24" @weight="fill" class="tio-fg-info shrink-0" />
      {{else}}
        <span
          class="tio-inline-row-center w-6 h-6 rounded-full tio-bg-danger-soft ring-2 tio-ring-danger shrink-0"
        >
          <PhXCircle @size="24" @weight="fill" class="tio-fg-danger" />
        </span>
      {{/if}}
      <span
        class="font-semibold
          {{if @isComplete 'tio-fg-muted' 'tio-fg-danger-body'}}
          group-hover:tio-fg-brand transition-colors"
      >{{@label}}</span>
    </div>
    <div class="tio-row-extra-loose">
      {{#if @summary}}
        <span
          class="font-medium
            {{if @isComplete 'tio-fg-primary' 'tio-fg-danger-body'}}
            text-right truncate max-w-[200px]"
        >
          {{#if (eq @summaryKind "course-cash")}}
            <span aria-hidden="true">{{htmlSafe (t "common.tas.course_cash.default")}}</span>
            <span class="sr-only">{{t "common.tas.course_cash.label"}}</span>
          {{else}}
            {{@summary}}
          {{/if}}
        </span>
      {{/if}}
      <span class="tio-fg-disabled group-hover:tio-fg-brand transition-colors">
        <PhPencilSimple @size="18" />
      </span>
    </div>
  </button>
</template>;

export default CompletedStepSummary;
